import React from 'react'
import { Divider } from 'antd'

const RenderGlossaryList = ({ datas }) => {
    if (!datas || datas.length === 0) {
        return <p>Aucun résultat</p>
    }

    return (
        <>
            {datas.map((item, i) => (
                <div key={i}>
                    <Divider orientation="left" plain>
                        <span className="glossary-title">{item.title}</span>
                    </Divider>
                    <p className="glossary-content">{item.content}</p>
                </div>
            ))}
        </>
    )
}

export default RenderGlossaryList
